import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
      display: "none"
    }
  },
  menuicon:{
    "& .css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root:hover ":{ 
        marginRight: "151px",
    }
  },
  menuicon1:{'& .super-app-theme--header': {
    backgroundColor: 'rgba(255, 7, 0, 0.55)',
  }
},
}));

const columns = [
    //{ field: 'id', headerName: '', width: 70, hide: true ,disableColumnMenu:true}, //removed extra column
    { field: 'label', width: 300, headerName: 'Customers',  headerClassName: 'super-app-theme--header',  },
];

//const AllFilterKey = "ALL";

export default function DataTable_1(props) {
    const { data,CustomerKeyChange } = props;
    const classes = useStyles();

    const selectedCustomerAssests = (Customers) => {
        const selectedIDs = new Set(Customers);
        const nonRepeatedRow = new Set(data?.map((ele) => ele?.id));
        const selectedRows = data?.filter((row) =>
            selectedIDs.has(row.id),
        );
       // const selectedCustomer = nonRepeatedRow?.size === selectedIDs?.size ?   selectedRows:"";
        CustomerKeyChange(selectedRows)
    } 

    return (
        <div style={{ height: 400, width: '100%' }}>
            <DataGrid
            
                rows={data}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                checkboxSelection
                GridLines="None"
                className={classes.root}
                onSelectionModelChange={(Customers) => {selectedCustomerAssests(Customers)}}
                disableSelectAllCheckbox
            />
        </div>
    );
}
